<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold mb-6">
            Detail Vehicle
          </div>

          <v-row
            class="mt-3">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                  
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              
              <v-btn
                to="/vehicle/data"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false
        },

        detail: {},

        rejected_reason: '',

        form: {
          id: '',
          sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: ''
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          load: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/order/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      async save () {
        this.message.error = ''
        const isValid = this.message.status === 'terima' ? this.approved_by.length > 0 ? await this.$refs.form.validate() : true : await this.$refs.form.validate()
        if (isValid) {
          

        this.process.form = true
        let approved_reason = {
          name: '',
          reason: ''
        }
        if (this.message.status === 'terima') {
          if(this.approved_by.length === 1 && this.approved_by[0] === 'Supervisor') {

            approved_reason = {
              name: 'Supervisor',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length === 1 && this.approved_by[0] === 'Sales Manager') {
            approved_reason = {
              name: 'Sales Manager',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length > 1) {
            approved_reason = {
              name: 'all',
              reason: this.approved_reason
            }
          } 
        }

        await post(`admin/customer_edit/approval`, {
          data: {
            edit_id: this.detail.id,
            status: this.message.status === 'terima' ? 'approved' : 'rejected',
            approved_by: this.message.status === 'terima' ? this.approved_by.length < 1 ? this.user.category_user_title === 'General Manager' ? this.detail.approved_by === 'Supervisor,Sales Manager' ? `Supervisor,Sales Manager,General Manager` : this.detail.approved_by === 'Supervisor' ? `Supervisor,General Manager` : this.detail.approved_by === 'Sales Manager' ? `Sales Manager,General Manager` : this.user.category_user_title : this.user.category_user_title : this.approved_by.length === 1 ? `${this.approved_by[0]},General Manager` : `Supervisor,Sales Manager,General Manager` : '',
            approved_reason: this.detail.approved_reason.name === '' ? JSON.stringify(approved_reason) : JSON.stringify(this.detail.approved_reason),
            rejected_reason: this.rejected_reason
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      }
    }
  }
</script>